import { useCallback, useRef } from 'react';

// A signed CDN URL lives to the END of a fixed 6-hour window (spec §7.1, Q5), so
// one minted just before a boundary can 403 minutes later. The grid treats an
// image error as "the window ended" and refetches the list (spec §7.2).
//
// ⚠️ THROTTLED. An image that fails for any OTHER reason (a missing object, a
// misconfigured CDN — see cdnSign.ts's padding note) would otherwise refetch on
// every failed <img> in a loop. One refetch per minute, whatever the cause.

export const IMAGE_REFETCH_MIN_INTERVAL_MS = 60_000;

export function shouldRefetchAfterImageError(lastMs: number | null, nowMs: number): boolean {
  return lastMs === null || nowMs - lastMs >= IMAGE_REFETCH_MIN_INTERVAL_MS;
}

export function useImageErrorRefetch(refetch: () => unknown): () => void {
  const last = useRef<number | null>(null);
  return useCallback(() => {
    const now = Date.now();
    if (!shouldRefetchAfterImageError(last.current, now)) return;
    last.current = now;
    void refetch();
  }, [refetch]);
}
